import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface ErrorAlertProps {
  message: string;
  onRetry?: () => void;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({ message, onRetry }) => (
  <div className="p-4 bg-brand-red-light border border-brand-red/30 rounded-lg flex items-start space-x-3">
    <AlertCircle className="w-5 h-5 text-brand-red shrink-0 mt-0.5" />
    <div className="flex-1 min-w-0">
      <p className="text-sm font-semibold text-brand-red">Something went wrong</p>
      <p className="text-xs text-brand-red/80 mt-0.5">{message}</p>
    </div>
    {onRetry && (
      <button
        type="button"
        onClick={onRetry}
        className="shrink-0 inline-flex items-center space-x-1 text-xs font-medium text-brand-red hover:text-brand-red-hover transition-colors"
      >
        <RefreshCw className="w-3.5 h-3.5" />
        <span>Retry</span>
      </button>
    )}
  </div>
);
